import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "webins-widget-step-cols webins-step-pagamento" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "center" }, null, -1)
const _hoisted_3 = { class: "box" }
const _hoisted_4 = {
  key: 0,
  class: "box-warning"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", null, "Pagamento", -1)
const _hoisted_6 = {
  key: 0,
  class: "box-failure"
}
const _hoisted_7 = { style: {"font-size":"18px"} }
const _hoisted_8 = ["innerHTML"]

import { computed, onMounted, ref } from "vue";
import Loading from "../../loading.vue";
import SummaryRisultati from "../../summary-risultati.vue";
import Popup from "../../popup.vue";
import PayPalButton from "./paypalButton.vue";
import ReservationItems from "./reservationItems.vue";
import { useNavigation, usePolizze, useWidget } from "@/composables";
import { RigaCarrello } from "@/models/RigaCarrello";
import dayjs from "dayjs";
import { CartCallbackItem } from "@/models";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { prev, next } = useNavigation();
const { options, isPaymentInternal, appCode, destinazioniPreventivatore, callCartCallback } = useWidget();
const { loading, totali, rigaCarrelloDati, acquista, aggiungiACarrello, transazione, finalizzaTransazione, testGetDatiAdesione, msgAddToCart } = usePolizze();

const popupAlert = ref(null);
const alertText = ref(null);
const addToCartDisabled = ref(false);
const msgErrCarrello = ref("");

const privacyUrl = computed(() => {
    if (options.value != null && options.value.privacyUrl != null && options.value.privacyUrl.length > 0) {
        return options.value.privacyUrl;
    }
    return "https://webins.it/privacy-policy";
});


// const addToCartDisabled = computed(() => acceptConditions.value !== true || acceptPrivacy.value !== true || reservation.value.selectedProducts.length <= 0);


const nextDisabled = computed(
    () =>{
        return false; // gestire poi per aggiungere al carrello del sito ospitante
    }
        
);

const nextStepWarnings = computed(() => {
    const warnings: string[] = [];

    return warnings;
});

const addToCart = async () => {
    var riga = rigaCarrelloDati.value.datiCarrello as RigaCarrello;
    debugger
    if(!options.value.addToCartCallback){
        // show msg errore con popup -> callback sito ospitante non impostata
        return;
    }

    var resAcquisto = await aggiungiACarrello(riga, appCode.value);
    debugger
    var msgErr = "";
    if(!resAcquisto){
        msgErr = "Si e' verificato un errore durante l'aggiunta al carrello";
    }
    else if( resAcquisto.adesioniErrori && resAcquisto.adesioniErrori.length){
        msgErr = resAcquisto.adesioniErrori[0].descrizione ||  "Si e' verificato un errore durante l'aggiunta al carrello";
    }
    else if( !resAcquisto.adesioni || !resAcquisto.adesioni.length || !resAcquisto.adesioni[0].guidAdesione ){
        msgErr = "Si e' verificato un errore durante l'aggiunta al carrello";
    }

    if(msgErr){
        alertText.value = msgErr;
        popupAlert.value.show();
        return;
    }

    loading.value = true;
    var guidAdesione = resAcquisto.adesioni[0].guidAdesione;

    var datiAd = resAcquisto.adesioni[0].datiAdesioneECommerce;

    var callbackData : CartCallbackItem = {
        nomePolizza: datiAd.pacchetto,
        terminiECondizioniPolizza: resAcquisto.adesioni[0].terminiECondizioniPolizza,
        guidAdesioneTemporanea: guidAdesione,
        numeroPartecipanti: datiAd.numeroPartecipanti,
        istanteInserimento: datiAd.istanteInserimento,
        inizioViaggio: datiAd.inizioViaggio,
        fineViaggio: datiAd.fineViaggio,
        durataViaggio: resAcquisto.adesioni[0].datiAdesione.durataViaggio,
        destinazione: datiAd.destinazione,
        importoViaggio: datiAd.importoViaggio,
        totalePremioDaPagare: datiAd.totalePremio
    };

    debugger
    
    //var res = callCartCallback(callbackData); // vedere cosa bisogna passare, probabilmente dati polizza
    var res = options.value.addToCartCallback(callbackData); // vedere cosa bisogna passare, probabilmente dati polizza
    res.then((msg)=>{
        debugger
        addToCartDisabled.value = true;
        msgAddToCart.value = msg || ""
        next();
        // OK -> mostra eventuale msg oppure msg default
        // blocca esecuzione widget
        return;
    }).catch((msgErr)=>{
        debugger
        msgErrCarrello.value = msgErr || "Si e' verificato un errore durante l'aggiunta al carrello"
        // show msg errore con popup
        return;
    }).finally(()=>{
        loading.value = false;
    })
};


const onTestConferma = async () => {
    //await testGetDatiAdesione('d349c489-493c-4805-b7ff-bd43958b6f70');
    await testGetDatiAdesione('80a22a8a-f5ce-46bb-a719-cfb1e801efcf');
    //await testGetDatiAdesione('f9cd4345-c246-4dc2-ae4e-6ead11176f3f');
    next();
}

const onTestAcquisto = async () => {
    //var resAcquisto = await acquista(rigaCarrelloDati.value.datiCarrello);

    //console.log(resAcquisto);
}

const onTestPostAcquisto = async() => {
    var res = await finalizzaTransazione();
    console.log(res);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(ReservationItems, {
            enableDel: false,
            showMainMedia: false,
            enableDetailButton: true
          })
        ]),
        (_unref(nextStepWarnings) && _unref(nextStepWarnings).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(nextStepWarnings), (warn, i) => {
                  return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(warn), 1))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(isPaymentInternal))
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["box box-payment", { 'payment-disabled': _unref(nextDisabled) }])
            }, [
              _hoisted_5,
              (_unref(transazione) && (_unref(transazione).adesioniErrori && _unref(transazione).adesioniErrori.length ))
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(transazione).adesioniErrori, (err, index) => {
                      return (_openBlock(), _createElementBlock("p", { key: index }, [
                        _createElementVNode("strong", null, _toDisplayString(err.descrizione), 1)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createVNode(PayPalButton)
            ], 2))
          : (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(["box box-payment", { 'payment-disabled': addToCartDisabled.value }])
            }, [
              _createElementVNode("button", {
                class: "btn",
                onClick: addToCart
              }, "Aggiungi al carrello"),
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(msgErrCarrello.value), 1)
              ])
            ], 2))
      ]),
      _createVNode(SummaryRisultati),
      _createVNode(Popup, {
        ref_key: "popupAlert",
        ref: popupAlert
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            style: {"font-weight":"bold"},
            innerHTML: alertText.value
          }, null, 8, _hoisted_8)
        ]),
        _: 1
      }, 512)
    ]),
    _createVNode(Loading, { isloading: _unref(loading) }, null, 8, ["isloading"])
  ], 64))
}
}

})